import { useContext } from 'react';
import StoreViewShoppingContext from '../context/storeViewShoppingContext';

export const useDashboardShoppingContext = () =>
  useContext(StoreViewShoppingContext);
